import type { BraintreePaymentItem } from '@store/reducers/subscription'
import type React from 'react'

import { clsJoin } from '@/utils'
import { DownloadButton } from '../DownloadButton'
import css from './styles.module.css'

interface Props {
  item: BraintreePaymentItem
  onDownload: (orderId: string) => void
}

export const PaymentItem: React.FC<Props> = ({ item, onDownload }) => {
  const handleClick = () => {
    onDownload(item.orderId)
  }

  return (
    <div className={css.payment_item}>
      <span className={css.info_label}>{item.createdAt}</span>
      <div className={css.button_wrapper}>
        <DownloadButton onClick={handleClick} />
      </div>
      <span className={css.info_label}>{item.orderId}</span>
      <span className={clsJoin(css.info_label, css.text_right)}>
        {item.amount}
      </span>
    </div>
  )
}
